global.BvHirek = {
  services: {},
  functions: {},
};
